import React, { ReactNode } from 'react';
import { Tooltip } from 'antd-v5';

interface TooltipProps {
  title: React.ReactNode;
  placement?: 'top' | 'bottom' | 'left' | 'right' | 'topLeft' | 'bottomLeft' | 'topRight' | 'bottomRight';
  children: ReactNode;
  open?: boolean;
  color?: string;
  'data-cy'?: string;
}

export const WithTooltip = ({
  title,
  children,
  placement,
  open,
  color,
  'data-cy': dataCy,
}: TooltipProps): ReactNode => {
  return (
    <Tooltip
      title={dataCy ? <span data-cy={dataCy}>{title}</span> : title}
      placement={placement}
      open={open}
      color={color}
    >
      {children}
    </Tooltip>
  );
};
